import React from "react";
import styled from "styled-components";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

const TabPanelWrapper = styled.div<{ isActive: boolean }>`
  width: 100%;
  padding: ${props => props.isActive ? '24px 0' : '0'};
  opacity: ${props => props.isActive ? 1 : 0};
  transition: opacity 0.3s ease-in-out;

  @media (max-width: 768px) {
    padding: ${props => props.isActive ? '16px 0' : '0'};
  }
`;

export default function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  const isActive = value === index;

  return (
    <TabPanelWrapper
      role="tabpanel"
      hidden={!isActive}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      isActive={isActive}
      {...other}
    >
      {isActive && <>{children}</>}
    </TabPanelWrapper>
  );
}
